import { useQuery } from 'react-query';

import { getHubs } from 'api/traps/Hubs/getHubs';

export const useGetHubs = (slug: string, page: number, search?: string, ordering?: string, enabled: boolean = true) => {
  const { data, refetch, isLoading } = useQuery('hubs', () => getHubs(slug, page, search, ordering), {
    refetchOnWindowFocus: false,
    enabled,
  });

  return { data, refetch, isLoading };
};
